<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" routerLink="/account/rbac-roles">RBAC Roles</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class="mr-auto">
        <button mat-raised-button color="primary" (click)="onEditRbacRole()" class="m-1 mr-2" appMarginRight id="add"
          *ngIf="canCreate">
          <mat-icon>add</mat-icon>
          New Role
        </button>

        <!-- The mat-menu and its trigger button share one guard. Angular Material renders mat-menu
             content in a CDK overlay, so an unguarded mat-menu leaks into the DOM. -->
        <ng-container *ngIf="canDelete">
          <mat-menu #appMenu="matMenu">
            <button mat-menu-item (click)="onToggleSelectAll()" [disabled]="!hasSelectableRoles()">
              <mat-icon *ngIf="isAllSelectableSelected()"> clear_all</mat-icon><mat-icon *ngIf="!isAllSelectableSelected()">select_all</mat-icon>
              {{ isAllSelectableSelected() ? 'Deselect' : 'Select' }} All
            </button>

            <button mat-menu-item (click)="onDeleteSelectedRbacRoles()" [disabled]="!listDataSource.selection.hasValue()">
              <mat-icon>delete</mat-icon> Delete Selected
            </button>
          </mat-menu>

          <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" style="min-width: 120px">
            <mat-icon>more_vert</mat-icon>
            List Menu
          </button>
        </ng-container>
      </span>

      <!-- Filtering and searching only make sense when the user can view the list. -->
      <ng-container *ngIf="canView">
      <button
        mat-raised-button
        type="button"
        class="m-1 mr-lg-3"
        id="filter-button"
        (click)="onFilter()"
        [matBadge]="'' + getActiveFilterCount()"
        [matBadgeHidden]="!isFiltered()"
        matBadgeColor="accent"
        matTooltip="Click this button to display filter options.">
        <mat-icon>filter_list</mat-icon> Filter
      </button>

      <form class="form-inline mx-1 my-0" (ngSubmit)="listDataSource.getData(true)">
        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="listDataSource.search"
          name="search"
          placeholder="Search"
          aria-label="Search"
          id="search-input" />

        <button
          mat-raised-button
          color="secondary"
          type="submit"
          class="mx-0 my-1"
          id="search-button"
          matTooltip="Click this button to run the current search.">
          <mat-icon>search</mat-icon> Search
        </button>
      </form>
      </ng-container>
    </div>
  </nav>

  <div class="alert alert-warning m-2" *ngIf="!canView">
    <mat-icon class="align-middle mr-2">info</mat-icon>
    You do not have permission to view RBAC roles.
    <span *ngIf="canCreate">You can still create new roles using the button above.</span>
  </div>

  <div class="alert alert-info m-2" *ngIf="canView && isFiltered()">
    <mat-icon class="align-middle mr-2">filter_list</mat-icon>
    A filter is applied to this list, so it does not show all RBAC roles.
    <button mat-stroked-button type="button" class="ml-2" (click)="onClearFilters()" matTooltip="Clear all filters and reload the list.">
      <mat-icon>clear_all</mat-icon> Clear Filter
    </button>
  </div>

  <div class="mat-elevation-z8 scroll-box" *ngIf="canView">
    <mat-paginator #paginator1 [length]="listDataSource?.total | async" [pageSize]="listDataSource.limit" [pageSizeOptions]="listDataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>

    <table mat-table [dataSource]="listDataSource" matSort matSortActive="date_created" matSortDirection="desc" matSortDisableClear>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          <!-- Hidden when every listed role is a system-managed default: those rows have no
               checkbox, so a select all control would have nothing to act on. -->
          <mat-checkbox *ngIf="hasSelectableRoles()" (change)="onToggleSelectAll()"
            [checked]="isAllSelectableSelected()"
            [indeterminate]="listDataSource.selection.hasValue() && !isAllSelectableSelected()"
            [matTooltip]="(isAllSelectableSelected() ? 'Deselect' : 'Select') + ' all RBAC roles that can be deleted.'">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox *ngIf="!isDefaultRole(row) && !isLockedRole(row)" (click)="$event.stopPropagation()"
            (change)="$event ? listDataSource.selection.toggle(row.id) : null"
            [checked]="listDataSource.selection.isSelected(row.id)"
            [matTooltip]="(listDataSource.selection.isSelected(row.id) ? 'Deselect' : 'Select') + ' this RBAC role.'">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by id.">
          ID #
        </th>
        <td mat-cell *matCellDef="let rbac_role">
          {{ rbac_role.id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by name.">
          Name
        </th>
        <td mat-cell *matCellDef="let rbac_role">
          {{ rbac_role.name | titlecase  }}
          <!-- Shown to super admins too, so support can recognise partner roles. -->
          @if (isPartnerRole(rbac_role)) {
            <mat-chip-set class="d-inline-block ml-2">
              <mat-chip [matTooltip]="'This role is managed by ' + utils.getAppName() + ' and can only be changed by ' + utils.getAppName() + ' support.'">
                Managed by {{ utils.getAppName() }}
              </mat-chip>
            </mat-chip-set>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="rbac_permissions_count">
        <th mat-header-cell *matHeaderCellDef matTooltip="The count of enabled permissions.">
          Permissions
        </th>
        <td mat-cell *matCellDef="let rbac_role">
          {{ rbac_role.rbac_permissions_count  }}
        </td>
      </ng-container>

      <ng-container matColumnDef="users_count">
        <th mat-header-cell *matHeaderCellDef [matTooltip]="'The count of associated ' + utils.getLangTerm('employees.plural', 'Employees').toLowerCase() + '.'">
          {{ utils.getLangTerm('employees.plural', 'Employees') }}
        </th>
        <td mat-cell *matCellDef="let rbac_role">
          <span style="text-decoration: underline;" [matTooltip]="getRoleUsersForTooltip(rbac_role)">
            {{ rbac_role.users_count  }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="date_created">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by creation data.">
          Created At
        </th>
        <td mat-cell *matCellDef="let rbac_role">
          {{ rbac_role.date_created ? ((rbac_role.date_created * 1000) | timezoneConvertMedium) : '' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="date_modified">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by modified date.">
          Updated At
        </th>
        <td mat-cell *matCellDef="let rbac_role">
          {{ rbac_role.date_modified ? ((rbac_role.date_modified * 1000) | timezoneConvertMedium) : '' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="180"></th>

        <td mat-cell *matCellDef="let rbac_role">
          <!-- Partner roles are read-only to clients: View replaces Edit, and Delete is hidden. -->
          @if (isLockedRole(rbac_role)) {
            @if (canView) {
              <button type="button" mat-button (click)="onViewRbacRole(rbac_role.id)">
                View
              </button>
            }
          } @else {
            @if (canEdit) {
              <button type="button" mat-button (click)="onEditRbacRole(rbac_role.id)">
                {{ isDefaultRole(rbac_role) ? 'Employees' : 'Edit' }}
              </button>
            }
            @if (!isDefaultRole(rbac_role) && canDelete) {
              <button type="button" mat-button (click)="onDeleteRbacRole(rbac_role.id, $event)">
                Delete
              </button>
            }
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="listColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: listColumns"></tr>
    </table>

    <mat-paginator #paginator2 [length]="listDataSource?.total | async" [pageSize]="listDataSource.limit" [pageSizeOptions]="listDataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>
  </div>
</div>
